import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "layer",
  "data-size": "small"
}
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "add form" }
const _hoisted_4 = { class: "label" }
const _hoisted_5 = {
  key: 0,
  class: "item"
}
const _hoisted_6 = {
  class: "checkbox",
  "data-info": ""
}
const _hoisted_7 = { class: "label" }
const _hoisted_8 = { for: "IsDirectLink" }
const _hoisted_9 = { class: "info" }
const _hoisted_10 = { class: "tooltip" }
const _hoisted_11 = { class: "item" }
const _hoisted_12 = { class: "input" }
const _hoisted_13 = ["disabled", "placeholder"]
const _hoisted_14 = { class: "item" }
const _hoisted_15 = { class: "input" }
const _hoisted_16 = { for: "ExpirationDays" }
const _hoisted_17 = ["value"]
const _hoisted_18 = {
  key: 1,
  class: "item"
}
const _hoisted_19 = {
  class: "checkbox",
  "data-info": ""
}
const _hoisted_20 = { class: "label" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = { for: "IsPrivate" }
const _hoisted_23 = { class: "info" }
const _hoisted_24 = { class: "tooltip" }
const _hoisted_25 = {
  key: 2,
  class: "item"
}
const _hoisted_26 = {
  class: "checkbox",
  "data-info": ""
}
const _hoisted_27 = { class: "label" }
const _hoisted_28 = { for: "IsProfileBranding" }
const _hoisted_29 = { class: "info" }
const _hoisted_30 = { class: "tooltip" }
const _hoisted_31 = {
  key: 3,
  class: "item"
}
const _hoisted_32 = { class: "input" }
const _hoisted_33 = { for: "Reason" }
const _hoisted_34 = ["placeholder"]
const _hoisted_35 = {
  key: 4,
  class: "item"
}
const _hoisted_36 = { class: "input" }
const _hoisted_37 = ["placeholder"]
const _hoisted_38 = {
  key: 5,
  class: "item"
}
const _hoisted_39 = { class: "message" }
const _hoisted_40 = { class: "text" }
const _hoisted_41 = { class: "item" }
const _hoisted_42 = {
  key: 6,
  class: "bundle"
}
const _hoisted_43 = {
  key: 0,
  class: "notify"
}
const _hoisted_44 = { class: "success" }
const _hoisted_45 = {
  key: 7,
  class: "validation-summary-errors"
}
const _hoisted_46 = { class: "list-user" }
const _hoisted_47 = { class: "title" }
const _hoisted_48 = { class: "info" }
const _hoisted_49 = { class: "label" }
const _hoisted_50 = { class: "name" }
const _hoisted_51 = { class: "info" }
const _hoisted_52 = { class: "label" }
const _hoisted_53 = {
  key: 0,
  class: "icon fastic-lock"
}
const _hoisted_54 = { class: "name" }
const _hoisted_55 = { class: "info" }
const _hoisted_56 = { key: 0 }
const _hoisted_57 = { key: 1 }
const _hoisted_58 = ["href", "onClick"]
const _hoisted_59 = {
  key: 0,
  class: "status"
}
const _hoisted_60 = { class: "view" }
const _hoisted_61 = { class: "count" }
const _hoisted_62 = { class: "copy" }
const _hoisted_63 = ["onClick"]
const _hoisted_64 = ["onClick"]

import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";


export default /*@__PURE__*/_defineComponent({
  __name: 'AssetProfileRelationList',
  props: {
    projectIdMaster: {},
    assetIdMaster: {},
    accentColor: {},
    headerColor: {},
    menuColor: {}
  },
  setup(__props: any) {

const props = __props;

const store = useStore();
const localizer = Localizer;
const isLoading = ref(false);
const isSuccess = ref(false);
const formData = ref<any>({ isPrivate: false, isProfileBranding: false });
const validationErrors = ref<any[]>([]);
const userProfile = ref<any>({ expirationDay: [], shareModes: [], isDirectLink: false, isBundleEmail: false });
const projectProfiles = ref<any[]>([]);
const profileRelations = ref<any[]>([]);
const isPrivateDisabled = ref(false);
const routes = (window as any).App.routes;

const emailBundleIds = computed(() => store.getters["privateAreaBundleEmailStore/emailBundleIds"]);

onMounted(() => {
	getProfileRelations();
});

async function getProfileRelations() {
	let response = (await Axios.post(routes.PrivateArea_Asset_GetProfileRelations, { projectIdMaster: props.projectIdMaster, assetIdMaster: props.assetIdMaster })).data;

	userProfile.value = response.userProfile;
	projectProfiles.value = response.projectProfiles;
	profileRelations.value = response.profileRelations;

	if (userProfile.value.shareModes.length === 1) {
		isPrivateDisabled.value = true;
	}

	formData.value.expirationDays = userProfile.value.expirationDays[0].value;
}

async function setProfileRelation() {
	validationErrors.value = [];

	isLoading.value = true;

	formData.value.projectIdMaster = props.projectIdMaster;
	formData.value.assetIdMaster = props.assetIdMaster;

	let successMessage = formData.value.isDirectLink ? localizer.get("PrivateArea.Common.GenerateLink_Success") : localizer.get("PrivateArea.Common.Asset_ProfileRelationList_SetProfileRelation_Success");
	try {
		await Axios.post(routes.PrivateArea_Asset_SetProfileRelation, formData.value, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } });

		let requestLogin = formData.value.isPrivate ? "login" : "public";

		GTagHelper.sendEvent("form_submit", "render_share", formData.value.expirationDays + "_" + requestLogin, 1);

		formData.value = {};

		isSuccess.value = true;

		store.dispatch("accountAreaToastStore/onAddToast", { message: successMessage, type: "Success" });

		getProfileRelations();
	} catch (error) {
		if (error.response && error.response.status === 400) {
			validationErrors.value = FormHelper.getValidationErrors(error.response.data);
		}
	}

	isLoading.value = false;
}

async function removeProfileRelation(profileRelationIdMaster: string) {
	var result = confirm(localizer.get("PrivateArea.Common.Asset_RemoveProfileRelation_Confirm"));
	if (result) {
		try {
			await Axios.post(routes.PrivateArea_Asset_RemoveProfileRelation, { projectIdMaster: props.projectIdMaster, assetIdMaster: props.assetIdMaster, profileRelationIdMaster: profileRelationIdMaster }, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } });

			store.dispatch("accountAreaToastStore/onAddToast", { message: localizer.get("PrivateArea.Common.Asset_ProfileRelationList_RemoveProfileRelation_Success"), type: "Success" });

			GTagHelper.sendEvent("click", "render_share", "remove");

			getProfileRelations();
		} catch (error) {
			if (error.response && error.response.status === 400) {
				let validationErrors = FormHelper.getValidationErrors(error.response.data);
				if (validationErrors.length !== 0) {
					store.dispatch("accountAreaToastStore/onAddToast", { message: validationErrors[0].message, type: "Error" });
				}
			}
		}
	}
}

function renderShareAnalytics(renderLinkURL: string) {
	GTagHelper.sendEvent("click", "render_share", "link");
}

function setBundleEmail() {
	if (emailBundleIds.value.some(x => x === props.assetIdMaster)) {
		store.commit("privateAreaBundleEmailStore/setEmailBundleIds", emailBundleIds.value.filter(x => x !== props.assetIdMaster));
	} else {
		store.commit("privateAreaBundleEmailStore/setEmailBundleIds", [...emailBundleIds.value, props.assetIdMaster]);
	}

	store.dispatch("privateAreaBundleEmailStore/saveEmailBundleIds");
}

function closeDialog() {
	let assetShareBox = document.getElementById("AssetShareBox"),
		body = document.getElementsByTagName("body")[0];

	if (assetShareBox && !assetShareBox.classList.contains("hden")) {
		assetShareBox.classList.add("hden");

		if (body.hasAttribute("data-overflow")) {
			body.removeAttribute("data-overflow");
		}
	}
}

function copyToClipboard(profileRelationLinkUrl: string) {
	navigator.clipboard.writeText(window.location.origin + profileRelationLinkUrl);
	store.dispatch("accountAreaToastStore/onAddToast", { message: localizer.get("PrivateArea.Common.Asset_ProfileRelationList_CopyClipboard_Success"), type: "Success" });
}

function formatDate(dateItem: string): string {
	if (dateItem == null) {
		return "";
	}

	let date = new Date(dateItem);
	return date.toLocaleString((<any>window).App.culture, {
		day: "numeric",
		month: "numeric",
		year: "numeric"
	});
}

function formatTime(dateItem: string): string {
	if (dateItem == null) {
		return "";
	}

	let date = new Date(dateItem);
	return date.toLocaleString((<any>window).App.culture, {
		hour: "numeric",
		minute: "2-digit"
	});
}

function isValidationError(controlName: string): boolean {
	return FormHelper.isControlValidationError(controlName, validationErrors.value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "top",
      style: _normalizeStyle([{'background-color': __props.headerColor}])
    }, [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (closeDialog())),
        class: "close icon fastic-close",
        style: _normalizeStyle([{'color': __props.menuColor}])
      }, null, 4),
      _createElementVNode("div", {
        class: "title",
        style: _normalizeStyle([{'color': __props.menuColor}])
      }, _toDisplayString(_unref(localizer).get("PrivateArea.Common.Asset_ProfileRelationList_Title")), 5)
    ], 4),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(localizer).get("PrivateArea.Common.Asset_ProfileRelationList_SetProfileRelation_Label")), 1),
        (userProfile.value.isDirectLink)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "IsDirectLink",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.isDirectLink) = $event)),
                    class: "checkbox"
                  }, null, 512), [
                    [
                      _vModelCheckbox,
                      formData.value.isDirectLink,
                      void 0,
                      { lazy: true }
                    ]
                  ]),
                  _createElementVNode("label", _hoisted_8, _toDisplayString(_unref(localizer).get("PrivateArea.Common.DirectLink_Label")), 1)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _cache[11] || (_cache[11] = _createElementVNode("span", { class: "icon fastic-info" }, null, -1)),
                  _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(localizer).get("PrivateArea.Common.DirectLink_Tooltip")), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "Email",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.email) = $event)),
              disabled: formData.value.isDirectLink === true,
              placeholder: _unref(localizer).get('PrivateArea.Common.Asset_ProfileRelationList_EmailPlaceholder'),
              class: _normalizeClass([{'input-validation-error': isValidationError('Email')}, 'textbox'])
            }, null, 10, _hoisted_13), [
              [
                _vModelText,
                formData.value.email,
                void 0,
                { lazy: true }
              ]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("label", _hoisted_16, _toDisplayString(_unref(localizer).get("PrivateArea.Common.Expiration")), 1),
            _withDirectives(_createElementVNode("select", {
              id: "ExpirationDays",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.expirationDays) = $event)),
              class: _normalizeClass([{'input-validation-error': isValidationError('ExpirationDays')}, 'dropdown'])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userProfile.value.expirationDays, (expirationDay, index) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: index,
                  value: expirationDay.value
                }, _toDisplayString(expirationDay.title), 9, _hoisted_17))
              }), 128))
            ], 2), [
              [_vModelSelect, formData.value.expirationDays]
            ])
          ])
        ]),
        (!isPrivateDisabled.value && formData.value.isDirectLink !== true)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "IsPrivate",
                    disabled: isPrivateDisabled.value,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.isPrivate) = $event)),
                    class: _normalizeClass([{'input-validation-error': isValidationError('IsPrivate')}, 'checkbox'])
                  }, null, 10, _hoisted_21), [
                    [
                      _vModelCheckbox,
                      formData.value.isPrivate,
                      void 0,
                      { lazy: true }
                    ]
                  ]),
                  _createElementVNode("label", _hoisted_22, _toDisplayString(_unref(localizer).get("PrivateArea.Common.RequestLogin")), 1)
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _cache[12] || (_cache[12] = _createElementVNode("span", { class: "icon fastic-info" }, null, -1)),
                  _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(localizer).get("PrivateArea.Common.PrivateDescriptionTooltip")), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (userProfile.value.isProfileBranding && userProfile.value.companyName)
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "IsProfileBranding",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.isProfileBranding) = $event)),
                    class: _normalizeClass([{'input-validation-error': isValidationError('IsProfileBranding')}, 'checkbox'])
                  }, null, 2), [
                    [
                      _vModelCheckbox,
                      formData.value.isProfileBranding,
                      void 0,
                      { lazy: true }
                    ]
                  ]),
                  _createElementVNode("label", _hoisted_28, _toDisplayString(_unref(localizer).get("PrivateArea.Common.ProfileBranding", userProfile.value.companyName)), 1)
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _cache[13] || (_cache[13] = _createElementVNode("span", { class: "icon fastic-info" }, null, -1)),
                  _createElementVNode("div", _hoisted_30, _toDisplayString(_unref(localizer).get("PrivateArea.Common.ProfileBrandingTooltip")), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (userProfile.value.isReasonActive)
          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("label", _hoisted_33, _toDisplayString(_unref(localizer).get("PrivateArea.Common.Reason")), 1),
                _withDirectives(_createElementVNode("textarea", {
                  id: "Reason",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.reason) = $event)),
                  placeholder: _unref(localizer).get('PrivateArea.Common.ProfileRelationList_Causal_Placeholder'),
                  class: _normalizeClass([{'input-validation-error': isValidationError('Reason')}, 'textarea'])
                }, null, 10, _hoisted_34), [
                  [
                    _vModelText,
                    formData.value.reason,
                    void 0,
                    { lazy: true }
                  ]
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (formData.value.isDirectLink !== true)
          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _withDirectives(_createElementVNode("textarea", {
                  id: "MessageNotes",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.messageNotes) = $event)),
                  placeholder: _unref(localizer).get('PrivateArea.Common.ProfileRelationList_Notes_Placeholder'),
                  class: _normalizeClass([{'input-validation-error': isValidationError('MessageNotes')}, 'textarea'])
                }, null, 10, _hoisted_37), [
                  [
                    _vModelText,
                    formData.value.messageNotes,
                    void 0,
                    { lazy: true }
                  ]
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (formData.value.isPrivate)
          ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _cache[14] || (_cache[14] = _createElementVNode("span", { class: "icon fastic-info" }, null, -1)),
                _createElementVNode("span", _hoisted_40, _toDisplayString(_unref(localizer).get("PrivateArea.Common.PrivateDefault")), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_41, [
          (!isLoading.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                onClick: _cache[8] || (_cache[8] = ($event: any) => (setProfileRelation())),
                class: "button",
                style: _normalizeStyle([{'background-color': __props.accentColor}])
              }, [
                (formData.value.isDirectLink !== true)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_unref(localizer).get("PrivateArea.Common.Asset_ProfileRelationList_SetProfileRelation_Button")), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(_unref(localizer).get("PrivateArea.Common.GenerateLink")), 1)
                    ], 64))
              ], 4))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "button load",
                style: _normalizeStyle([{'background-color': __props.accentColor}])
              }, [...(_cache[15] || (_cache[15] = [
                _createElementVNode("div", { class: "loader" }, null, -1)
              ]))], 4))
        ]),
        (userProfile.value.isBundleEmail)
          ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
              (emailBundleIds.value.some(x => x === __props.assetIdMaster))
                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                    _createElementVNode("span", _hoisted_44, [
                      _cache[16] || (_cache[16] = _createElementVNode("span", { class: "marker" }, [
                        _createElementVNode("span", { class: "icon fastic-check" })
                      ], -1)),
                      _createTextVNode(" " + _toDisplayString(_unref(localizer).get("PrivateArea.Common.Bundle_AddButton")), 1)
                    ]),
                    _createElementVNode("span", {
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (setBundleEmail())),
                      class: "remove"
                    }, _toDisplayString(_unref(localizer).get("PrivateArea.Common.Remove")), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (setBundleEmail())),
                    class: "button"
                  }, _toDisplayString(_unref(localizer).get("PrivateArea.Common.Bundle_AddedTitle")), 1))
            ]))
          : _createCommentVNode("", true),
        (validationErrors.value.length !== 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(validationErrors.value, (validationError) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: validationError.name
                  }, _toDisplayString(validationError.message), 1))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_46, [
        _createElementVNode("div", _hoisted_47, _toDisplayString(_unref(localizer).get("PrivateArea.Common.ProfileRelationList_Title")), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projectProfiles.value, (projectProfile) => {
          return (_openBlock(), _createElementBlock("div", {
            key: projectProfile.email,
            class: "item"
          }, [
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("div", _hoisted_49, _toDisplayString(_unref(localizer).get("PrivateArea.Common.Asset_ProfileRelationList_Admin")), 1),
              _createElementVNode("div", _hoisted_50, _toDisplayString(projectProfile.email), 1)
            ])
          ]))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(profileRelations.value, (profileRelation) => {
          return (_openBlock(), _createElementBlock("div", {
            key: profileRelation.idMaster,
            class: "item"
          }, [
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("div", _hoisted_52, [
                _createTextVNode(_toDisplayString(_unref(localizer).get("PrivateArea.Common.Asset_ProfileRelationList_Guest")), 1),
                (profileRelation.isPrivate)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_53))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_54, _toDisplayString(profileRelation.email), 1),
              _createElementVNode("div", _hoisted_55, [
                _createElementVNode("div", null, _toDisplayString(_unref(localizer).get("PrivateArea.Common.CreatedBy")) + ": " + _toDisplayString(profileRelation.authorDescription), 1),
                (userProfile.value.isReasonActive && profileRelation.reason)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_56, _toDisplayString(_unref(localizer).get("PrivateArea.Common.Reason")) + ": " + _toDisplayString(profileRelation.reason), 1))
                  : _createCommentVNode("", true),
                (profileRelation.isExpirationDate)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_57, _toDisplayString(_unref(localizer).get("PrivateArea.Common.ProfileRelation_ExpirationDate", formatDate(profileRelation.expirationDate))), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", null, [
                  _createElementVNode("a", {
                    href: profileRelation.linkUrl,
                    target: "_black",
                    onClick: ($event: any) => (renderShareAnalytics(profileRelation.linkUrl)),
                    class: "link"
                  }, _toDisplayString(_unref(localizer).get("PrivateArea.Common.RenderLink")), 9, _hoisted_58)
                ])
              ]),
              (profileRelation.assetViewedCounter != 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                    _createElementVNode("span", _hoisted_60, [
                      (profileRelation.assetViewedCounter === 1)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(_unref(localizer).get("PrivateArea.Common.ProfileRelationList_IsAssetViewed_Label")), 1)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("span", _hoisted_61, _toDisplayString(profileRelation.assetViewedCounter), 1),
                            _createTextVNode(" " + _toDisplayString(_unref(localizer).get("PrivateArea.Common.ProfileRelationList_AssetViewedCounter_Label")), 1)
                          ], 64)),
                      _createTextVNode(" (" + _toDisplayString(formatDate(profileRelation.assetViewedLastDate)) + " " + _toDisplayString(_unref(localizer).get("PrivateArea.Common.ProfileRelationList_AssetViewedLastTime_Label")) + " " + _toDisplayString(formatTime(profileRelation.assetViewedLastDate)) + ") ", 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_62, [
              _cache[17] || (_cache[17] = _createElementVNode("span", { class: "icon fastic-link" }, null, -1)),
              _createElementVNode("span", {
                onClick: ($event: any) => (copyToClipboard(profileRelation.linkUrl)),
                class: "label"
              }, _toDisplayString(_unref(localizer).get("PrivateArea.Common.CopyLink")), 9, _hoisted_63)
            ]),
            _createElementVNode("div", {
              class: "remove",
              onClick: ($event: any) => (removeProfileRelation(profileRelation.idMaster))
            }, _toDisplayString(_unref(localizer).get("PrivateArea.Common.Asset_ProfileRelationList_RemoveProfileRelation_Button")), 9, _hoisted_64)
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})